module.exports = {
          srcSet: __webpack_public_path__ + "4886a2b2580ffbd5c4985cc919d96b25-452.png"+" 452w",
          images:[ {path: __webpack_public_path__ + "4886a2b2580ffbd5c4985cc919d96b25-452.png",width: 452,height: 178}],
          src: __webpack_public_path__ + "4886a2b2580ffbd5c4985cc919d96b25-452.png",
          toString:function(){return __webpack_public_path__ + "4886a2b2580ffbd5c4985cc919d96b25-452.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeUlEQVR4nCWNrQqCQQAEPzFo8XEMljmYAzX4001iEUUQs1WfwOoT7r2EHIYtu8POENwHd8HaSh2C8+ApuAwOrdRJK3XUh08vgt/gPfhoxUfwFdwGr8F1Bw5BgpfgO3hu+Aweg5ug3dqvOzwNzoK34KrhuP0tPYu+/QDqvkMg2pP3/AAAAABJRU5ErkJggg==",
          width: 452,
          height: 178
        }